document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.faq__item').forEach(item => {
        item.addEventListener('click', function() {
            const target = this.getAttribute('data-answer');
            const isOpen = this.classList.contains('faq__item--open');

            document.querySelectorAll('.faq__item').forEach(faqItem => {
                faqItem.classList.remove('faq__item--open');
            });
            document.querySelectorAll('.faq__block').forEach(block => {
                block.classList.remove('faq__block--open');
            });

            if (!isOpen) {
                this.classList.add('faq__item--open');
                const selectedBlock = document.getElementById(target);
                selectedBlock.classList.add('faq__block--open');
            }
        });
    });

    if (window.innerWidth >= 769) {
        const firstFaq = document.getElementById('faq-answer-1');
        if (firstFaq) {
            firstFaq.classList.add('faq__block--open');
            document.querySelector('.faq__item').classList.add('faq__item--open');
        }
    }

    document.querySelectorAll('.faq__subtitle').forEach(subtitle => {
        subtitle.addEventListener('click', function() {
            const parentBlock = this.parentElement;

            const isOpen = parentBlock.classList.contains('faq__block--open');

            document.querySelectorAll('.faq__block').forEach(block => {
                block.classList.remove('faq__block--open');
            });

            if (!isOpen) {
                parentBlock.classList.add('faq__block--open');
            }
        });
    });
});